import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { MEDDICScores } from '@vendasta/sales-opportunities';

@Component({
  selector: 'sales-ui-meddic-selector',
  templateUrl: './m-e-d-d-i-c-selector.component.html',
  standalone: false,
})
export class MEDDICSelectorComponent implements OnInit, OnChanges {
  @Input() scores: MEDDICScores;
  @Input() scoresKey: string;
  @Input() scoreI18nKey: string;

  @Output() scoresChanged = new EventEmitter<MEDDICScores>();
  scoreValue: number;

  handleSelection($event: MatSelectChange): void {
    const newScores = Object.assign({}, this.scores);
    newScores[this.scoresKey] = $event.value;
    this.scoresChanged.emit(newScores);
  }

  ngOnChanges(): void {
    this.updateScoreValue();
  }

  ngOnInit(): void {
    this.updateScoreValue();
  }

  private updateScoreValue(): void {
    if (this.scores && this.scoresKey) {
      this.scoreValue = this.scores[this.scoresKey];
    }
  }
}
